<template>
  <div>
    <top></top>
    <el-row>
      <el-col :xs="1" :sm="3" :md="4" :lg="5" :xl="6"></el-col>
      <el-col :xs="22" :sm="18" :md="16" :lg="14" :xl="12">
        <div class="container">
          <div class="successBox">
            <div class="content" v-if="langSet == 'zh'">您的需求已发送！</div>
            <div class="return" v-if="langSet == 'zh'" @click="Retuen">点击返回</div>
            <div class="content" v-if="langSet == 'en'">Your requirements have been sent!</div>
            <div class="return" v-if="langSet == 'en'" @click="Retuen">Click back</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { getCompanyList, getCollect, sendEmial, getUser } from "@/api/api";
export default {
  props: {},
  components: {
    top,
    bottom,
  },
  data() {
    return {
      langSet: "",
    };
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "zh";
    this.memberid = localStorage.getItem("memberid");
  },
  methods: {
    Retuen(){
      this.$router.push('/');
    }
  },
};
</script>

<style lang="scss">
.successBox {
  padding: 100px 0 300px 0;
  text-align: center;
  box-sizing: border-box;
}
.content {
  font-size: 30px;
}
.return {
  width: 153px;
  height: 40px;
  background: linear-gradient(
    180deg,
    #ccd280 0%,
    #c4ca78 29%,
    #b8be6b 69%,
    #a1a751 100%
  );
  border-radius: 3px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  font-size: 18px;
  margin: 68px auto 40px;
  cursor: pointer;
}
@media only screen and (max-width: 767px) {
}
</style>